export default __webpack_public_path__ + "static/what-is-it-1-9752838f64511634d6c77263b8f94969.png";